export default __webpack_public_path__ + "static/media/alert.5a447ef9.svg";